import { Draft } from '@reduxjs/toolkit';
import { IHistoryState } from './IHistoryState';

export function applySaveProjectToHistoryReducer(state: Draft<IHistoryState>) {
  for (const page of Object.values(state.byProductId)) {
    page.savedAtIndex = page.index;
  }
}
